import { render, staticRenderFns } from "./CustomerCumulativeSalesNumberDisplayer.vue?vue&type=template&id=6f9a6e73"
import script from "./CustomerCumulativeSalesNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./CustomerCumulativeSalesNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports